// centralize all localStorage keys used by the app.
// Keeping them in one place avoids collisions and simplifies future migrations.

//==============================================================================
// Active realm flag. Set via URL (see RealmTracker). 
//==============================================================================s
export const STORAGE_ACTIVE_REALM = 'app.auth.activeRealm'; // 'user' | 'carrier'

//==============================================================================
// User realm keys (normal flow) 
//==============================================================================
export const STORAGE_USER = {
  token: 'app.auth.user.token',
  // Optional: persist user bootstrap payloads if you need them in the UI layer
  menus: 'app.auth.user.menus',
  permissions: 'app.auth.user.permissions',
  profile: 'app.auth.user.profile', // ex: { id, name, aCCOUNT etc. }
};

//==============================================================================
// Carrier realm keys (invite flow) 
//==============================================================================
export const STORAGE_CARRIER = {
  token: 'app.auth.carrier.token',
  expiresUtc: 'app.auth.carrier.expiresUtc',
  session: 'app.auth.carrier.session', // { CarrierLoginId, AccountId, CarrierId }
  menus: 'app.auth.carrier.menus',
  permissions: 'app.auth.carrier.permissions',
  profile: 'app.auth.carrier.profile', // ex: { Account, Carrier, etc. }
};

//==============================================================================
/// Legacy keys (for backward-compat migration only) 
//==============================================================================
export const LEGACY_KEYS = {
  token: 'token', // your previous global token key
};
